import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d5e887ae&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e887ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wumingbao/Desktop/hxproject/qingfa/erp-flexible-web21/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5e887ae')) {
      api.createRecord('d5e887ae', component.options)
    } else {
      api.reload('d5e887ae', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d5e887ae&scoped=true&", function () {
      api.rerender('d5e887ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inputs/com/input/index.vue"
export default component.exports